import { CelebrationAccordion } from "@components/adapters/celebration/Accordion";
import type { AccordionProps } from "@components/contracts/Accordion.types";

export const Accordion: React.FC<AccordionProps> = (props) => (
  <CelebrationAccordion {...props} />
);

export type { AccordionProps };
